import React, {useEffect, useState} from "react";
import {AlertTypes, IAlertData, setAlert, SmartSelect, TextField} from "@leap4/frontend";
import {IALData} from "../../modules/home/home";
import {Dispatch} from 'redux';

interface IAdvertiserLoginsSelectProps {
    selectedAL: string,
    advertiserLogins: IALData[],
    isLoading: boolean,
    setSelectedAL: (alId: string) => void,
    setAlert: ({msg, type, d, timeout}: IAlertData) => (d: Dispatch<any>) => void
}

export const AdvertiserLoginsSelect = ({
                                          selectedAL,
                                          advertiserLogins,
                                          isLoading,
                                          setSelectedAL,
                                          setAlert
                                      }: IAdvertiserLoginsSelectProps) => {
    const [selectedIdx, setSelectedIdx] = useState(0);
    const handleChange = (idx: number) => {
        const selectedAL = advertiserLogins[idx];
        setSelectedAL(selectedAL.aLId)
    }

    const getPlaceholder = () => {
        if (!advertiserLogins) return 'Loading';
        if (!advertiserLogins.length) return 'No advertiser logins';
        else return 'Choose An Advertiser Login';
    }

    const getSelectedInd = () => {
        return advertiserLogins?.findIndex(p => p.aLId === selectedAL)
    }

    useEffect(() => {
        const idx = advertiserLogins?.findIndex(p => p.aLId === selectedAL);
        setSelectedIdx(idx > -1 ? idx : 0);
    }, [advertiserLogins, selectedAL]);

    const items = advertiserLogins?.map(o => ({name: o.aLName, value: o.aLId}))
    const inputProps = {
        style: {
            color: 'white',
            WebkitTextFillColor: 'white',
            border: '1px solid #001080'
        }
    }
    return <>
        {items?.length ? <SmartSelect items={items}
                                      selectedItemInd={selectedIdx}
                                      setSelectedState={handleChange}
                                      selectProps={{size: 'small', fullWidth: true, ...inputProps}}
                                      disabled={isLoading}
                                      textFieldProps={{inputProps: {...inputProps}}}

            /> :
            <TextField placeholder={"No Advertiser Logins"} size={"small"}
                       style={{color: 'white',width:'100px'}}
                       disabled

                       inputProps={{...inputProps}} />
        }


    </>
}